<template>
<DataProvider :endpoint='mountUrlAndParams().url' :filter='mountUrlAndParams().filter' ref='dataProvider'>
  <div slot-scope='{ data: response, loading }'>
    <DataTable
      v-if='response && response.data'
      :data='response && response.data'
      ref='dataTable'
      :title="$t('analysisPerServiceDelivered.searchResults')"
      :customTotal='(response && response.total) || 0'
      @pagination='handlePagination'
      @click-row='openDialog'
      :currentSort.sync='filter.orderBy'
      :currentSortOrder.sync='filter.order'
      :selectable='false'
      :loading='loading'
      customHeader
      :endpoint='mountUrlAndParams().url'
      :filter='mountUrlAndParams().filter'
      :labels='labels'
      :formatLabelFunction='formatLabels'
      :createHeader='createHeaderPDF'
      @search-options='searchOptions'
      @search-query='handleSearch'
      :fileName="$t('analysisPerServiceDelivered.fileName')"
    >
      <template slot='footer' slot-scope='{ pagination }'>
        <v-row style='justify-content: flex-end;'>
          <v-col cols='auto'>
            <md-field>
              <label for='pages'>
                {{ $t('assistantsList.perPage') }}
              </label>

              <md-select v-model='pagination.perPage' name='pages' >
                <md-option
                  v-for='item in pagination.perPageOptions'
                  :key='item'
                  :label='item'
                  :value='item'
                >
                  {{ item }}
                </md-option>
              </md-select>
            </md-field>
          </v-col>
        </v-row>
      </template>

      <template slot='cells' slot-scope='{ item }'>
        <!-- inicio -->
        <md-table-cell
          :md-label='labels[0]'
          md-sort-by='process_time'
        > {{ formatLabels(item, 0) }}
        </md-table-cell>

        <!-- nome do sertviço -->
        <md-table-cell
          :md-label='labels[1]'
        > {{ formatLabels(item, 1) }}
        </md-table-cell>

        <!-- cpf -->
        <md-table-cell
          :md-label='labels[2]'
          style='display: table-cell;'
          v-html='formatLabels(item, 2)'
        />

        <!-- codigo de retono -->
        <md-table-cell
          :md-label='labels[3]'
          style='display: table-cell;'
          v-html='formatLabels(item, 3)'
        />

        <!-- mensagem de retorno -->
        <md-table-cell
          :md-label='labels[4]'
          style='display: table-cell;'
          v-html='formatLabels(item, 4)'
        />
      </template>
    </DataTable>

    <v-dialog v-model='dialog' max-width='700px' scrollable persistent>
      <ChatConversation
        :chatLoader='chatLoader'
        :chatData='chatData'
        :chatInfo='chatInfo'
        :channelConfig='channelConfig'
        :key='chatInfo._id'
        :idConversationAnalysisPerDeliveredService='idConversation'
        @close='closeDialog'
      />
    </v-dialog>
  </div>
</DataProvider>
</template>

<script>
import Pagination from '@/components/Pagination.vue'
import chatsList from '@/pages/data/chatsList'
import DateInterval from '@/components/DateInterval.vue'
import DataTable from '@/components/AnalysisPerServiceDeliveredResultTable/Table.vue'
import DataProvider from '@/components/DataProvider'
import ChatConversation from '@/components/ChatConversation'
import { mapFields } from 'vuex-map-fields'
import * as moment from 'moment'
import { selectedLocale } from '@/plugins/i18n'
import { mask } from 'vue-the-mask'

export default {
  directives: { mask },
  props: {
    title: {
      type: String
    }
  },
  components: {
    // eslint-disable-next-line vue/no-unused-components
    Pagination,
    // eslint-disable-next-line vue/no-unused-components
    DateInterval,
    DataTable,
    DataProvider,
    ChatConversation
  },
  watch: {
    DateInterval: {
      deep: true,
      handler (nV) {
        this.updatedDate()
      }
    }
  },
  data () {
    return {
      search: null,
      labels: [
        this.$t('analysisPerServiceDelivered.start'),
        this.$t('analysisPerServiceDelivered.serviceName'),
        this.$t('analysisPerServiceDelivered.citizensCPF'),
        this.$t('analysisPerServiceDelivered.returnCode'),
        this.$t('analysisPerServiceDelivered.returnMessage')
      ],
      data: this.response,
      dialog: false,
      chatLoader: false,
      showFilter: true,
      filter: {
        order: 'desc',
        orderBy: 'request_datetime',
        page: 0,
        perPage: null,
        by: null,
        search: null
      },
      tableData: chatsList,
      searchedData: [],
      chatData: {},
      chatInfo: {},
      idConversation: '',
      channelConfig: null
    }
  },
  computed: {
    ...mapFields('analysisPerServiceDeliveredFilter', ['citizensCPF', 'service', 'returnCode']),
    ...mapFields('reports', ['dateInterval'])
  },
  methods: {
    mountUrlAndParams () {
      const from = this.dateInterval.timestamp1
      const to = this.dateInterval.timestamp2
      return {
        url: `${process.env.VUE_APP_REPORTS_BACKEND}/interactions/services`,
        filter: {
          to,
          from,
          order: this.filter.order,
          orderBy: 'request_datetime',
          page: this.filter.page,
          perPage: this.filter.perPage,
          requester: this.filter.requester || undefined,
          service: this.filter.service || undefined,
          status: this.filter.status || undefined
        }
      }
    },

    searchOptions (nV) {
      if (nV?.length > 0) {
        this.$set(this.filter, 'opt', this.mappingOptions(nV.toString()))
      } else {
        this.$delete(this.filter, 'opt')
      }
    },

    cpfMasked (cpfValue) {
      if (cpfValue) {
        let cpfFormatted = cpfValue.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4')
        return cpfFormatted
      } else {
        return ''
      }
    },

    /* -------
      Filtro
    ---------- */
    handleSearch (searchText) {
      if (searchText) {
        this.$set(this.filter, 'search', searchText)
      } else {
        this.$delete(this.filter, 'search')
      }
    },

    changeFilters () {
      let newFilter = { ...this.filter }
      newFilter = {
        ...this.filter,
        requester: this.citizensCPF,
        service: this.service,
        status: this.returnCode
      }
      this.filter = { ...newFilter }
      this.$nextTick(() => {
        this.$refs.dataProvider.load()
      }, 1000)
    },

    toggleShowFilter () {
      this.showFilter = !this.showFilter
    },

    /* -----------
      Pagination
    -------------- */
    handlePagination (pagination, oldPagination) {
      const newFilter = {}
      const { currentPage, perPage } = pagination
      if (currentPage && this.filter.page !== currentPage - 1) {
        newFilter.page = currentPage - 1
      }
      if (perPage && this.filter.perPage !== perPage) {
        newFilter.perPage = perPage
      }
      Object.assign(this.filter, newFilter)
    },

    /* -------------------
      Card infor por row
    ---------------------- */
    async openDialog (rowProps) {
      const conversationId = rowProps.item._source?.conversation_id
      this.dialog = true
      this.chatLoader = true
      try {
        const result = await this.$axios.get(`${process.env.VUE_APP_REPORTS_BACKEND}/interactions`, {
          params: {
            page: 0,
            perPage: 1000,
            conversationId: conversationId,
            event: 'search-interactions',
            time_zone: moment().format('Z')
          }
        })
        this.chatData = result.data
        this.chatInfo = rowProps.item
        this.idConversation = rowProps.item._source.conversation_id
      } catch (error) {
        // console.log(error)
      }
      this.chatLoader = false
    },

    closeDialog () {
      this.dialog = false
    },

    /* --------------------
      Formato data e hora
    ----------------------- */
    updatedDate () {
      this.filter.from = this.dateInterval.timestamp1
      this.filter.to = this.dateInterval.timestamp2
      this.$refs.dataProvider.load()
    },

    formatDate (item, type) {
      let date = item[type]
      return moment(date).locale(selectedLocale).format('L LT')
    },

    leadZeros (pad, number) {
      return String(number).padStart(pad, '0')
    },

    checkIfFormatDuration (item) {
      return item._source.total_duration ? this.fomartDuration(item._source.total_duration) : '-'
    },

    fomartDuration (duration) {
      let minutes, seconds
      if (duration >= 1) {
        minutes = Math.floor(duration)
      }
      const fractionOfSeconds = Math.ceil(duration) - duration
      seconds = Math.round(fractionOfSeconds * 60)
      return `${minutes ? minutes + 'min' : ''}${seconds ? seconds + 's' : ''}`
    },

    /* -------------------------
      Labels e infos da tabela
    ---------------------------- */
    formatLabels (item, i) {
      // eslint-disable-next-line camelcase
      switch (i) {
        // inicio
        case 0:
          return this.formatDate(item._source.external_api_call, 'request_datetime')
        // nome do sertviço
        case 1:
          return item._source.external_api_call.service
        // cpf
        case 2:
          return this.cpfMasked(item._source.external_api_call.requester)
        // codigo de retono
        case 3:
          return item._source.external_api_call.status
        // mensagem de retorno
        case 4:
          let status = parseInt(item._source.external_api_call.status)
          if (status >= 300) {
            return item._source.external_api_call.status_label
          } else {
            let message = JSON.stringify(item._source.external_api_call.raw_response)
            return message
          }
        default:
          break
      }
    },

    /* ----------------
      PDFs e arquivos
    ------------------- */
    createHeaderPDF (doc, total) {
      doc.setFontSize(14)
      doc.setFont(undefined, undefined, '700')
      doc.text(15, 10, this.$t('analysisPerServiceDelivered.searchResults'))

      doc.setFontSize(10)
      doc.setFont('times', undefined, '700')
      doc.text(15, 17, this.$t('search.timeCourse'))
      doc.setFont('times', undefined, '300')

      const from = this.dateInterval.timestamp1
      const to = this.dateInterval.timestamp2
      let formattedDate1 = moment(from).utcOffset(0, true).format('DD/MM/YYYY HH:mm:ss')
      let formattedDate2 = moment(to).utcOffset(0, true).format('DD/MM/YYYY HH:mm:ss')
      doc.text(29, 17, `${formattedDate1} até ${formattedDate2}`)

      doc.setFont('times', undefined, '700')
      doc.text(15, 22, this.$t('search.totalConversations'))
      doc.setFont(undefined, undefined, '300')
      doc.text(46, 22, `${total}`)

      const tableOffsetY = 30
      return tableOffsetY
    }
  },
  created () {
    this.dateInterval = {
      timestamp1: moment().subtract(1, 'week').startOf('day').format('YYYY-MM-DD[T]HH:mm:ss'),
      timestamp2: moment().endOf('day').format('YYYY-MM-DD[T]HH:mm:ss')
    }
    this.filter.from = this.dateInterval.timestamp1
    this.filter.to = this.dateInterval.timestamp2
  }
}
</script>

<style lang='css'>
#custom-filter-input > .v-text-field .v-input__control {
  margin: auto;
}
</style>
